<template>
    <v-card>
        <div v-if="loadingOverlay" style="padding:50px; width:100%; text-align: center">
            <v-progress-circular
                    :width="3"
                    color="red"
                    indeterminate="">
            </v-progress-circular>
        </div>
        <v-form v-model="valid" ref="editContactListForm" @submit="save" onSubmit="return false" v-if="!loadingOverlay">
            <v-toolbar dark color="primary">
                <v-btn icon dark @click="cancel()">
                    <v-icon>mdi-close</v-icon>
                </v-btn>
                <v-toolbar-title>Edit Contact list</v-toolbar-title>
            </v-toolbar>
            <v-card-text>
                <v-container fluid>
                    <v-layout>
                        <v-flex md6>

                            <v-text-field label="Name of Contact list"
                                          v-model="contactList.name"
                                          counter="100"
                                          ref="contactListName"
                                          :rules="serverValidation('name','Contact List Name')"
                            ></v-text-field>
                        </v-flex>
                    </v-layout>
                    <v-alert dense outlined color="info">Click Add Contact or Add User Below to Add New Contacts or Existing Users to this List.  Users Listed Here Will be Contacted Based on Their Profile Phone Number</v-alert>
                    <v-banner outlined class="green text--black font-weight-bold">
                        Contacts
                        <template v-slot:actions>
                            <v-btn text v-on:click="addContact()">Add Contact</v-btn>
                        </template>
                    </v-banner>
                    <v-layout>
                        <v-flex md12>
                            <v-simple-table v-show="contactList && contactList.contacts && contactList.contacts.length > 0">
                                <template v-slot:default>
                                    <thead>
                                    <tr>
                                        <th>Contact Name</th>
                                        <th>Phone Number</th>
                                        <th>Remove</th>
                                    </tr>
                                    </thead>
                                    <tbody>
                                    <tr v-for="(contact,index) in contactList.contacts">
                                        <td>
                                            <v-text-field v-model="contact.name" required></v-text-field>
                                        </td>
                                        <td>
                                            <v-text-field v-model="contact.phoneNumber" required
                                                          v-mask="'(###) ### - ####'"></v-text-field>
                                        </td>
                                        <td>
                                            <v-btn @click="deleteContact(index)">Delete</v-btn>
                                        </td>
                                    </tr>
                                    </tbody>
                                </template>
                            </v-simple-table>
                        </v-flex>
                    </v-layout>
                    <v-banner outlined class="green text--black font-weight-bold">
                        Users
                        <template v-slot:actions>
                            <v-btn text v-on:click="addUsers()">Add User(s)</v-btn>
                        </template>
                    </v-banner>
                    <v-layout flex>
                        <v-flex md12>
                            <v-simple-table
                                    v-show="contactList && contactList.users && contactList.users.length > 0"
                                    item-key="id">
                                <template v-slot:default>
                                    <thead>
                                    <tr>
                                        <th>User Name</th>
                                        <th>Phone Number</th>
                                        <th>Remove</th>
                                    </tr>
                                    </thead>
                                    <tbody>
                                    <tr v-for="(user,index) in contactList.users">
                                        <td>
                                            {{user.name}}
                                        </td>
                                        <td>
                                            {{user.phoneNumber}}
                                        </td>
                                        <td>
                                            <v-btn @click="deleteUser(index)">Delete</v-btn>
                                        </td>
                                    </tr>
                                    </tbody>
                                </template>
                            </v-simple-table>
                        </v-flex>
                    </v-layout>
                    <!-- User Search Dialog -->
                    <v-dialog :eager="true" v-model="searchUserDialog" fullscreen hide-overlay transition="dialog-bottom-transition">
                        <v-card>
                            <v-toolbar dark color="primary">
                                <v-btn icon dark @click="cancelSelectUsers()">
                                    <v-icon>mdi-close</v-icon>
                                </v-btn>
                                <v-toolbar-title>Select Users</v-toolbar-title>
                            </v-toolbar>
                            <v-card-text>
                                <SearchUsers ref="userSearchDialog"
                                             :limit-to-organization="organizationId"
                                             @selected="selectUsers"
                                             @cancel="cancelSelectUsers"
                                ></SearchUsers>
                            </v-card-text>
                            <v-card-actions>
                                <v-btn class="mx-2" color="warning" outlined @click="cancelSelectUsers()">Cancel</v-btn>
                            </v-card-actions>
                        </v-card>
                    </v-dialog>
                    <confirm-dialog ref="confirmDialog"></confirm-dialog>
                </v-container>
            </v-card-text>
            <v-card-actions>
                <v-btn class="mx-2" outlined type="button" @click="cancel()" color="warning" :disabled="saveOverlay">Cancel</v-btn>
                <v-btn class="mx-2" outlined type="submit" color="success" :disabled="saveOverlay">Save</v-btn>
                <v-progress-circular
                        :width="3"
                        v-show="saveOverlay"
                        color="red"
                        indeterminate="">
                </v-progress-circular>
            </v-card-actions>
        </v-form>
    </v-card>
</template>

<script>

    import api from '@/api';
    import {validationMixin} from '@/mixins/validations'
    import SearchUsers from "../../user/SearchUsers";
    import ConfirmDialog from "@/components/common/ConfirmDialog";

    export default {
        name:"EditOrganizationContactList",
        mixins:[validationMixin],
        components: {SearchUsers,ConfirmDialog},
        data() {
            return {
                loadingOverlay : true,
                saveOverlay: false,
                valid: false,
                contactList : {},
                organizationId : null,
                contactListId : null,
                searchUserDialog: false
            }
        },
        methods: {
            open(contactListId,organizationId) {
                this.reset();
                this.organizationId = organizationId;
                this.contactListId = contactListId;
                this.get();
            },
            reset() {
                this.loadingOverlay = true;
                this.contactList = {contacts:[{}]};
                this.violations = [];
            },
            get() {
                api.contactList.get(this.contactListId).then((cl) => {
                    this.loadingOverlay = false;
                    this.contactList = cl;
                    this.$nextTick(this.$refs.contactListName.focus);
                },() => {

                }).finally(() => {
                    this.loadingOverlay = false;
                })
            },
            validate() {
                let bad = false;
                if (this.contactList.contacts) {
                    this.contactList.contacts.forEach((c) => {
                        if ((!c.name || c.name == '') || (!c.phoneNumber || c.phoneNumber == '')) {
                            bad = true;
                        } else if (c.phoneNumber.replace(/\D/g,'').length != 10) {
                            bad = true;
                        }
                    })
                }
                if (bad) {
                    return false;
                }
                return true;
            },
            save() {
                if (!this.validate()) {
                    this.$root.$emit('globalError','Please Specify Names and 10 Digit Phone Numbers For Each Contact');
                    return;
                }
                this.saveOverlay = true;
                this.contactList.organizationId = this.organizationId;
                api.contactList.patch(this.contactList).then((data) => {
                    this.reset();
                    this.$emit('saved',data);
                    this.$root.$emit('globalMessage','Contact List Updated');
                },(error) => {
                    if (this.processErrors(error) == this.RESPONSE_VALIDATION) {
                        this.$refs.editContactListForm.validate();
                    }
                }).finally(() => {
                    this.saveOverlay = false;
                })
            },
            addContact() {
                if (!this.contactList.contacts) {
                    this.contactList.contacts = [];
                }
                this.contactList.contacts.push({});
            },
            cancel() {
                this.reset();
                this.$emit('cancelled');
            },
            deleteContact(index) {
                this.$refs.confirmDialog.open('Remove Contact','Are You Sure?').then((confirm) => {
                    if (confirm) {
                        this.contactList.contacts.splice(index, 1);
                    }
                });
            },
            deleteUser(index) {
                this.$refs.confirmDialog.open('Remove User', 'Are You Sure?').then((confirm) => {
                    if (confirm) {
                        this.contactList.users.splice(index, 1);
                    }
                });
            },
            addUsers() {
                this.searchUserDialog = true;
                this.$refs.userSearchDialog.open();
            },
            cancelSelectUsers() {
                this.searchUserDialog = false;
            },
            selectUsers(idMap) {
                if (!this.contactList.users) {
                    this.$set(this.contactList,'users',[]);
                }
                for (let newUserId in idMap) {
                    let newUser = idMap[newUserId];
                    let has = false;
                    for (let i=0;i<this.contactList.users.length;i++) {
                        if (this.contactList.users[i].id == newUser.id) {
                            has = true;
                        }
                    }

                    if (!has) {
                        this.contactList.users.push({
                            id : newUser.id,
                            name : newUser.firstName,
                            phoneNumber : newUser.phoneNumber
                        });
                    }

                }

                this.componentKey = this.componentKey+1;
                this.$nextTick(() => {
                    this.searchUserDialog = false;
                });
            },
        }
    }

</script>